export default "__VITE_ASSET__md13gw2z__"